import mutation from './mutation.graphql.js'
import query from './query.graphql.js'
import { useDataValue } from 'Simple/Data.js'
import { useMutation, useClient } from 'Data/Api.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import {
  useNotifications,
  notifyError,
  notifySuccess,
} from 'Logic/Notifications.js'

export default function useDataOnSubmit(props) {
  let [, executeMutation] = useMutation(mutation)
  let [, notify] = useNotifications()
  let email_config = useDataValue({
    viewPath: props.viewPath,
    context: 'event_action',
    path: 'data.email_template',
  })
  let location_uuid = useDataValue({
    context: 'automation',
    path: 'location_id',
    viewPath: props.viewPath,
  })
  let client = useClient()
  let setFlowTo = useSetFlowTo(props.viewPath)
  return async function onSubmit({ value, originalValue, change }) {
    try {
      let from = email_config.from

      if (email_config.from === 'DEFAULT') {
        let { data: default_email } = await client
          .query(query, { location_uuid })
          .toPromise()
        from = default_email.comms_defaults[0].outbound_email.email
      }

      let mutationResponse = await executeMutation({
        from,
        to: value.email,
        subject: email_config.subject,
        content: email_config.content,
        advanced_editor: email_config.advanced_editor,
      })
      if (mutationResponse.error) {
        notify(notifyError('Something went wrong, please try again later.'))
      } else {
        if (mutationResponse.data.comms_send_preview_email.ok) {
          notify(notifySuccess('Preview email sent.'))
          setFlowTo(normalizePath(props.viewPath, '../No'))
        } else {
          notify(notifyError('Something went wrong, please try again later.'))
        }
      }
    } catch (error) {
      notify(notifyError(error.message))
    }
  }
}
